import React, { useEffect, useState } from "react";
import Product from "../Integration/CardHome";
import "../../Css/Home.css";
import Header from "../Integration/Header";
import MenuLateralCompleto from "../Integration/BarraMenu";
import Carrossel from "../Integration/Carrossel";
import Carrossel2 from "../Integration/Carrossel2";
import Carrossel3 from "../Integration/Carrossel3";
import FooterMenu from "../Integration/FooterMenu";
import Spinner from "../Integration/Spinner";
import { db } from "../../Middleware/Firebase/firebase";
import { collection, query, getDocs, where } from "firebase/firestore";
import { useLocation, useNavigate } from "react-router-dom";

export default function Home() {
  const location = useLocation();
  const navigate = useNavigate();

  const [lines, setLines] = useState({
    line1: [],
    line2: [],
    line3: [],
    line4: [],
    line5: [],
    line6: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchMarketingData() {
      try {
        setLoading(true);

        const collectionRef = collection(db, "Db", "Marketing", "Home");

        const lineNames = ["line1", "line2", "line3", "line4", "line5", "line6"];

        // Dispara todas as queries em paralelo
        const promises = lineNames.map(async (line) => {
          const q = query(
            collectionRef,
            where("line", "==", line),
            where("status", "==", "Aproved") // ✅ mais confiável que usar '!='
          );

          const snapshot = await getDocs(q);

          const items = snapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .filter((item) => {
              // Se não houver 'expired', mantém
              if (!item.expired) return true;

              const now = new Date();

              // Se 'expired' for Timestamp:
              const expiryDate =
                typeof item.expired?.toDate === "function"
                  ? item.expired.toDate()
                  : new Date(item.expired); // caso seja string/data serializada

              return expiryDate > now;
            });

          return [line, items];
        });

        const resultsArray = await Promise.all(promises);
        const resultsObj = Object.fromEntries(resultsArray); // { line1: [...], line2: [...] }

        setLines(resultsObj);
      } catch (error) {
        console.error("Erro ao buscar marketing:", error);
        // Se quiser redirecionar em caso de erro:
        // navigate("/Home");
      } finally {
        setLoading(false);
      }
    }

    fetchMarketingData();
  }, [location.pathname, navigate]);

  const renderLine = (lineData) => (
    <section className="home-container">
      <div className="grid-products">
        {lineData.map((item) => (
          <div className="card-3d" key={item.id}>
            <Product {...item} />
          </div>
        ))}
      </div>
    </section>
  );

  return (
    <>
      {loading && <Spinner />}

      <div>
        <Header />
        <MenuLateralCompleto />

        <Carrossel />
        {renderLine(lines.line1)}
        {renderLine(lines.line2)}

        <Carrossel2 />
        {renderLine(lines.line3)}
        {renderLine(lines.line4)}

        <Carrossel3 />
        {renderLine(lines.line5)}
        {renderLine(lines.line6)}

        <FooterMenu />
      </div>
    </>
  );
}